import styled from '@emotion/styled';

import { TabletWidth } from '../../../global.style';
import { getColor } from '../../common/UICommon';
import { BoxWithLinearBorder } from '../../styledComponent/Boxes.style';

export const ProductContainer = styled(BoxWithLinearBorder)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  height: 84px;
  padding: 15px;
  border-radius: 8px;
  background: ${getColor('LIGHT_CREAM')};
  margin-bottom: 16px;

  @media (max-width: ${TabletWidth}px) {
    margin-bottom: 14px;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const ProductContainerLeft = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
`;
export const ProductContainerRight = styled(ProductContainerLeft)`
  text-align: right;
`;

export const ProductPrice = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 6px;
  color: ${getColor('GRAY_80')};
  text-align: end;
`;

export const ProductDescription = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 6px;
  color: ${getColor('GRAY_80')};
`;

export const ProductTotalPriceWrapper = styled.div``;

export const ProductTotalPrice = styled.span`
  line-height: 24px;
  font-size: 14px;
  font-weight: 500;
  color: ${getColor('GRAY_60')};
  text-align: left;
`;

export const ProductPriceDescription = styled(ProductTotalPrice)``;

export const ProductPriceWithoutBargainText = styled(ProductTotalPrice)`
  text-decoration: line-through;
  margin-left: 4px;
`;

export const ProductLabelWrapper = styled.div<{ isPicked: boolean }>`
  padding: 2px 12px;
  background: ${({ isPicked }) => (isPicked ? getColor('PURPLE_60') : getColor('DARK_CREAM'))};
  border-radius: 100px;
  display: flex;
`;

export const ProductLabelText = styled.span<{ isPicked: boolean }>`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: ${({ isPicked }) => (isPicked ? getColor('WHITE') : getColor('GRAY_80'))};
`;

export const ProductBestValueContainer = styled.div`
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0px 16px;
  border-radius: 32px;
  height: 28px;
  background: ${getColor('PURPLE_GRADIENT')};
  display: flex;
  align-items: center;
`;

export const ProductBestValueLabel = styled.label`
  color: white;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
`;
